import React, { Component } from 'react'

export default class Test extends Component {
    render() {
        //console.log('TEST PROPS', this.props)
        return (
            <div>
                test
            </div>
        )
    }
}
